function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { node, object, string } from 'prop-types';
import { styled } from '@mui/material/styles';
import clsx from 'clsx';
const Root = styled('div')(_ref => {
  let {
    theme: {
      spacing
    }
  } = _ref;
  return {
    padding: "".concat(spacing(), " ").concat(spacing(2))
  };
});

/**
 * Correctly positions arbitrary content at the top of `SovosPageLayout`
 */
const SovosGenericHeroBanner = _ref2 => {
  let {
    children,
    classes,
    className,
    style,
    ...rest
  } = _ref2;
  return /*#__PURE__*/React.createElement(Root, _extends({
    className: clsx('sovosGenericHeroBanner', className, classes === null || classes === void 0 ? void 0 : classes.root),
    style: style
  }, rest), children);
};
SovosGenericHeroBanner.propTypes = {
  /**
   * The content of the hero banner
   */
  children: node.isRequired,
  /**
   * Override or extend the styles applied to the component
   */
  classes: object,
  /**
   * Extend the class name applied to the root element
   */
  className: string,
  /**
   * Inline styles applied to the root element
   */
  style: object
};
export default SovosGenericHeroBanner;